var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('Table',{attrs:{"columns":_vm.tableColumn,"data":_vm.ChargeDetails,"size":"small"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }